export default "__VITE_PUBLIC_ASSET__9244a4a8__"